import { Controller } from "@hotwired/stimulus"

// OAuth credentials controller - shows/hides credential fields based on enabled providers
// Usage:
//   <div data-controller="oauth-credentials">
//     <input type="checkbox" value="google" data-oauth-credentials-target="checkbox"
//            data-action="change->oauth-credentials#toggle">
//     <div data-oauth-credentials-target="credentials" data-provider="google" class="hidden">
//       ... credential fields ...
//     </div>
//   </div>
//
export default class extends Controller {
  static targets = ["checkbox", "credentials"]

  connect() {
    this.updateVisibility()
  }

  toggle() {
    this.updateVisibility()
  }

  updateVisibility() {
    const enabledProviders = this.checkboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value)

    this.credentialsTargets.forEach(credentialsSection => {
      const provider = credentialsSection.dataset.provider
      if (enabledProviders.includes(provider)) {
        credentialsSection.classList.remove('hidden')
      } else {
        credentialsSection.classList.add('hidden')
      }
    })
  }
}
